// frontend/src/hooks/useWebSocketEvents.js

import { useEffect, useCallback } from 'react'

export const useWebSocketEvents = (handlers = {}) => {
  const handleWebSocketMessage = useCallback((event) => {
    const message = event.detail

    console.log('Новое сообщение по вебсокет:', message)

    switch (message.type) {
      case 'technical_card_update':
        if (handlers.onTechnicalCardUpdate) {
          handlers.onTechnicalCardUpdate(message.data)
        }
        break

      case 'sheet_update':
        if (handlers.onSheetUpdate) {
          handlers.onSheetUpdate(message.data)
        }
        break

      case 'estimate_update':
        if (handlers.onEstimateUpdate) {
          handlers.onEstimateUpdate(message.data)
        }
        break

      case 'progress_update':
        if (handlers.onProgressUpdate) {
          handlers.onProgressUpdate(message.data)
        }
        break

      case 'connection_established':
        if (handlers.onConnected) {
          handlers.onConnected(message.data)
        }
        break

      case 'connection':
        if (handlers.onConnected) {
          handlers.onConnected(message.data)
        }
        break

      case 'pong':
        // Heartbeat response
        break

      default:
        console.log('Неизвестный тип сообщения:', message.type)
    }
  }, [handlers])

  useEffect(() => {
    window.addEventListener('websocket_message', handleWebSocketMessage)

    return () => {
      window.removeEventListener('websocket_message', handleWebSocketMessage)
    }
  }, [handleWebSocketMessage])
}
